import { baseApi } from "./base.api";

export const talukasApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchTalukas: build.query({
      query: (params) => ({ url: "/talukas/fetch", method: "GET", params }),
      providesTags: ["Taluka"],
    }),
    fetchAllTalukas: build.query({
      query: () => ({ url: "/talukas/fetch/all", method: "GET" }),
      providesTags: ["Taluka"],
    }),
    fetchTalukaByDistrict: build.query({
      query: (district_id) => ({ url: `/talukas/by/district/${district_id}`, method: "GET" }),
      providesTags: ["Taluka"],
    }),
    fetchTrashedTalukas: build.query({
      query: (params) => ({ url: "/talukas/fetch/trashed", method: "GET", params }),
      providesTags: ["Taluka"],
    }),
    fetchTalukaById: build.query({
      query: (id) => ({ url: `/talukas/fetch/${id}`, method: "GET" }),
      providesTags: ["Taluka"],
    }),
    createTaluka: build.mutation({
      query: (body) => ({ url: "/talukas/create", method: "POST", body }),
      invalidatesTags: ["Taluka", "Permission"],
    }),
    updateTaluka: build.mutation({
      query: ({ id, body }) => ({ url: `/talukas/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Taluka", "Permission"],
    }),
    restoreTaluka: build.mutation({
      query: (id) => ({ url: `/talukas/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Taluka"],
    }),
    bulkRestoreTalukas: build.mutation({
      query: (body) => ({ url: "/talukas/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Taluka"],
    }),
    deleteTaluka: build.mutation({
      query: (id) => ({ url: `/talukas/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Taluka"],
    }),
    bulkDeleteTalukas: build.mutation({
      query: (body) => ({ url: "/talukas/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Taluka"],
    }),
    destroyTaluka: build.mutation({
      query: (id) => ({ url: `/talukas/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Taluka"],
    }),
    bulkDestroyTalukas: build.mutation({
      query: (body) => ({ url: "/talukas/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Taluka"],
    }),
  }),
});

export const {
  useFetchTalukasQuery,
  useFetchAllTalukasQuery,
  useFetchTrashedTalukasQuery,
  useFetchTalukaByIdQuery,
  useCreateTalukaMutation,
  useUpdateTalukaMutation,
  useRestoreTalukaMutation,
  useBulkRestoreTalukasMutation,
  useDeleteTalukaMutation,
  useBulkDeleteTalukasMutation,
  useFetchTalukaByDistrictQuery,
  useDestroyTalukaMutation,
  useBulkDestroyTalukasMutation,
} = talukasApi;
